<h3>{{ isEditMode ? 'Editar declaración' : 'Alta de declaración' }}</h3>

<div class="w-full flex flex-col gap-[1.25rem]">
  <div class="form-control">
    <label class="text-neutral-900" for="declaration-name">Nombre de la declaración</label>
    <div class="input-icon">
      <input
        [(ngModel)]="name"
        [disabled]="isSubmitting"
        autocomplete="off"
        id="declaration-name"
        placeholder="Por ejemplo: Declaración jurada de conflicto de interés"
        type="text">
    </div>
  </div>

  <div class="form-control w-full">
    <label class="text-neutral-900">Tipo</label>
    <core-select
      [(ngModel)]="type"
      [disabled]="isSubmitting"
      [options]="typeOptions"
      placeholder="Selecciona un tipo"/>
  </div>

  <div class="form-control w-full">
    <label class="text-neutral-900">
      {{ type === 'numeric' ? 'Valor numérico declarado' : 'Valor declarado' }}
    </label>
    @if (type === 'numeric') {
      <input
        [(ngModel)]="declarationValue"
        [disabled]="isSubmitting"
        autocomplete="off"
        class="cd-text-b3 font-light"
        placeholder="Por ejemplo: 12"
        type="text">
    } @else {
      <core-select
        [(ngModel)]="booleanAnswer"
        [disabled]="isSubmitting"
        [options]="booleanAnswerOptions"
        placeholder="Selecciona Sí o No"/>
    }
  </div>

  <div class="form-control flex-1 w-full">
    <label class="text-neutral-900" for="declaration-description">Descripción</label>
    <textarea
      [(ngModel)]="description"
      [disabled]="isSubmitting"
      id="declaration-description"
      placeholder="Descripción opcional"
      rows="3"></textarea>
  </div>

  <div class="w-full flex flex-col gap-2">
    <span class="cd-text-b4 text-neutral-700">Variable de riesgo (opcional)</span>

    <div class="px-2 pb-2 shadow-e1 w-full flex flex-col gap-2 rounded-lg">
      @if (isLoadingVariableConfig) {
        <div class="w-full grid grid-cols-1 gap-2 py-2">
          <div class="h-9 rounded bg-neutral-200 animate-pulse"></div>
          <div class="h-9 rounded bg-neutral-200 animate-pulse"></div>
          <div class="h-9 rounded bg-neutral-200 animate-pulse"></div>
        </div>
      } @else {
        <div class="w-full">
          <input
            [(ngModel)]="variableName"
            [disabled]="isSubmitting || isLoadingVariableConfig"
            autocomplete="off"
            class="w-full rounded-lg border border-[var(--color-neutral-200)] bg-neutral px-3 py-[0.25rem] cd-text-b4"
            placeholder="Nombre de variable"
            type="text">
        </div>

        <div class="w-full gap-2 grid grid-cols-12 items-end">
          <core-select
            [(ngModel)]="selectedConceptIds"
            [disabled]="isSubmitting || isLoadingConcepts || isLoadingVariableConfig"
            [labelTemplate]="selectedTpl"
            [multiple]="true"
            [options]="conceptOptions"
            class="w-full col-span-12 md:col-span-12 xl:col-span-5"
            placeholder="Conceptos de riesgo"
            placement="top"/>

          @if (type === 'numeric') {
            <core-select
              [(ngModel)]="ruleComparator"
              [disabled]="isSubmitting || isLoadingVariableConfig"
              [labelTemplate]="selectedTpl"
              [options]="associationComparatorOptions"
              class="w-full col-span-12 md:col-span-4 xl:col-span-3"
              placeholder="Comparador"
              placement="top"/>

            <div class="form-control col-span-12 md:col-span-4 xl:col-span-2">
              <input
                [(ngModel)]="ruleThreshold"
                [disabled]="isSubmitting || isLoadingVariableConfig"
                autocomplete="off"
                class="cd-text-b3 font-light"
                placeholder="Umbral activación"
                style="padding: 0.125rem 0.5rem"
                type="text">
            </div>
          } @else {
            <div
              class="bg-neutral border-1 rounded-lg py-1 w-full px-2 flex flex-row gap-2 items-center min-w-0 col-span-12 md:col-span-4 xl:col-span-3"
              style="border-color: var(--color-neutral-200)">
              <img alt="Icon" class="filter-neutral-800 h-4" src="/assets/icons/feather/bookmark.svg">
              <span class="cd-text-b4 truncate flex-1 min-w-0">Igual</span>
            </div>

            <core-select
              [(ngModel)]="booleanRuleAnswer"
              [disabled]="isSubmitting || isLoadingVariableConfig"
              [labelTemplate]="selectedTpl"
              [options]="booleanAnswerOptions"
              class="w-full col-span-12 md:col-span-4 xl:col-span-2"
              placeholder="Activar si"
              placement="top"/>
          }

          <div class="form-control col-span-12 md:col-span-4 xl:col-span-2">
            <input
              [(ngModel)]="ruleWeight"
              [disabled]="isSubmitting || isLoadingVariableConfig"
              autocomplete="off"
              class="cd-text-b3 font-light"
              placeholder="Peso"
              style="padding: 0.125rem 0.5rem"
              type="text">
          </div>
        </div>

        <span class="cd-text-b5 text-neutral-500">
          Si no defines nombre de variable, la declaración se guarda solo con su valor declarado. Los conceptos y regla quedan inactivos.
        </span>
      }
    </div>
  </div>

  @if (errorMessage) {
    <div class="rounded-lg border border-[var(--color-red-300)] bg-[var(--color-red-a10)] px-3 py-2">
      <span class="cd-text-b4 text-red-600">{{ errorMessage }}</span>
    </div>
  }
</div>

<div class="w-full flex flex-row items-center gap-4">
  <button
    (click)="submit()"
    [disabled]="isSubmitting"
    class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]"
    style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/save.svg">
    <span class="hidden lg:block cd-text-md truncate capitalize">Guardar</span>
  </button>

  <button
    (click)="cancel()"
    [disabled]="isSubmitting"
    class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem]"
    style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/x.svg">
    <span class="hidden lg:block cd-text-md truncate capitalize">Cancelar</span>
  </button>
</div>

<ng-template #selectedTpl let-multiple="multiple" let-option let-placeholder="placeholder">
  <div class="bg-neutral border-1 rounded-lg py-1 w-full px-2 flex flex-row gap-2 items-center min-w-0"
       style="border-color: var(--color-neutral-200)">
    <img alt="Icon" class="filter-neutral-800 h-4" src="/assets/icons/feather/bookmark.svg">
    @if (multiple) {
      @if (option?.length) {
        <span class="cd-text-b4 truncate flex-1 min-w-0">
          {{ option[0]?.label }}@if (option.length > 1) { +{{ option.length - 1 }} }
        </span>
      } @else {
        <span class="cd-text-b4 truncate flex-1 min-w-0">{{ placeholder }}</span>
      }
    } @else if (option?.label) {
      <span class="cd-text-b4 truncate flex-1 min-w-0">{{ option.label }}</span>
    } @else {
      <span class="cd-text-b4 truncate flex-1 min-w-0">{{ placeholder }}</span>
    }
  </div>
</ng-template>
